<template>
  <component :is="tag" :class="classes">
    <slot />
  </component>
</template>

<script>
export default {
  props: {
    asSpan: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'white',
      validator: (value) => {
        return ['white', 'purple', 'black', 'purple-grey', 'orange', 'inherit'].includes(value)
      }
    },
    size: {
      type: String,
      default: 'medium',
      validator: (value) => {
        return ['extraSmall', 'small', 'medium', 'large', 'extraLarge'].includes(value)
      }
    },
    weight: {
      type: String,
      default: 'normal',
      validator: (value) => {
        return ['normal', 'bold'].includes(value)
      }
    },
    align: {
      type: String,
      default: 'left',
      validator: (value) => {
        return ['left', 'center', 'right'].includes(value)
      }
    }
  },

  computed: {
    tag () {
      return this.asSpan ? 'span' : 'div'
    },

    classes () {
      return [
        'commonText',
        `commonText_${this.size ? this.size : 'medium'}`,
        `commonText_${this.color ? this.color : 'white'}`,
        `commonText_${this.weight ? this.weight : 'normal'}`,
        `commonText_${this.align ? this.align : 'left'}`
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.commonText {
  &_extraSmall {
    font-size: 12px;
    line-height: 14px;
  }

  &_small {
    font-size: 14px;
    line-height: 21px;
  }

  &_medium {
    font-size: 16px;
    line-height: 24px;
  }

  &_large {
    font-size: 18px;
    line-height: 27px;
  }

  &_extraLarge {
    font-size: 20px;
    line-height: 30px;
  }

  &_white {
    color: #fff;

    :deep(strong) {
      color: #fff;
    }
  }

  &_orange {
    background: linear-gradient(130.92deg, #f8b700 -0.63%, #f87900 58%, #ae35dd 114.33%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  &_black {
    color: #2d2d2d;

    :deep(strong) {
      color: #2d2d2d;
    }
  }

  &_purple-grey {
    color: #797088;

    :deep(strong) {
      color: #797088;
    }
  }

  &_inherit {
    color: inherit;

    :deep(strong) {
      color: inherit;
    }
  }

  &_purple {
    color: #cebbfa;

    :deep(strong) {
      color: #cebbfa;
    }
  }

  &_normal {
    font-weight: 400;
  }

  &_bold {
    font-weight: 700;
  }

  &_left {
    text-align: left;
  }

  &_center {
    text-align: center;
  }

  &_right {
    text-align: right;
  }
}
</style>
